import { Injector } from "@angular/core";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { LookupGetService } from "../../../../shared/service/lookup-service/lookup-get.service";

export class FieldDefinition {
  constructor(private injector: Injector) { }

  messageHeaderFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'messagetype',
          defaultValue: '',
          className: 'flex-1',
          type: 'input',
          props: {
            label: 'Message Type',
            readOnly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'messagenumb',
          defaultValue: '',
          className: 'flex-1',
          type: 'input',
          props: {
            label: 'Message Number',
            readOnly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'messagesenderidentifier',
          defaultValue: '',
          className: 'flex-1',
          type: 'input',
          props: {
            label: 'Sender ID',
            readOnly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      key: 'messagedateformat',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'messagedate',
          defaultValue: '',
          className: 'flex-1',
          type: 'input',
          props: {
            label: 'Message Date',
            readOnly: true,
            disabled: true,
          },
        },
      ],
    },
  ];


  messageAckFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'evmessagenumb',
          defaultValue: '',
          className: 'flex-1',
          type: 'input',
          props: {
            label: 'EV Message Number',
            readOnly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'originalmessagenumb',
          defaultValue: '',
          className: 'flex-1',
          type: 'input',
          props: {
            label: 'Message Number',
            readOnly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'originalmessagereceiveridentifier',
          defaultValue: '',
          className: 'flex-1',
          type: 'input',
          props: {
            label: 'Receiver ID',
            readOnly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      key: 'originalmessagedateformat',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'originalmessagedate',
          defaultValue: '',
          className: 'flex-1',
          type: 'input',
          props: {
            label: 'Date',
            readOnly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'transmissionacknowledgmentcode',
          defaultValue: '',
          className: 'flex-1',
          type: 'input',
          props: {
            label: 'Message Acknoledgment Code',
            readOnly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'parsingerrormessage',
          defaultValue: '',
          className: 'flex-1',
          type: 'input',
          props: {
            label: 'Parsing error message',
            readOnly: true,
            disabled: true,
          },
        },
      ],
    },
  ];

  entityAckFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'reportname',
          defaultValue: '',
          className: 'flex-1',
          type: 'select',
          props: {
            label: 'Entity',
            options: this.injector.get(LookupGetService).loadCachedOptions('reportname'),
            valueProp: 'code',
            labelProp: 'name',
            readOnly: true,
            disabled: true,
            required: true,
            attributes: {
              title: 'Entity',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'localnumber',
          defaultValue: '',
          className: 'flex-1',
          type: 'input',
          props: {
            label: 'Local Number',
            readOnly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'evCode',
          defaultValue: '',
          className: 'flex-1',
          type: 'input',
          props: {
            label: 'EV Code',
            readOnly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      key: 'originalmessagedateformat',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'operationtype',
          defaultValue: '',
          className: 'flex-1',
          type: 'select',
          props: {
            label: 'Operation Type',
            options: this.injector.get(LookupGetService).loadCachedOptions('operationtype'),
            valueProp: 'code',
            labelProp: 'name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Operation Type',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'operationresult',
          defaultValue: '',
          className: 'flex-1',
          type: 'select',
          props: {
            label: 'Operation Result',
            options: this.injector.get(LookupGetService).loadCachedOptions('operationresult'),
            valueProp: 'code',
            labelProp: 'name',
            readOnly: true,
            disabled: true,
            required: true,
            attributes: {
              title: 'Operation Result'
            }
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'operationresultdesc',
          defaultValue: '',
          className: 'flex-1',
          type: 'input',
          props: {
            label: 'Operation Result Description',
            readOnly: true,
            disabled: true,
          },
        },
      ],
    },
  ];
}